module.exports = __webpack_public_path__ + "static/media/form.425fddf6.svg";